module.exports = __webpack_public_path__ + "static/media/street-glide-special-snake-venom.1eeb341b.png";